export const parseSearchList = (searchParams: URLSearchParams, key: string) => {
  const valueArray = searchParams.get(key)
  if (valueArray === null) {
    return []
  }
  const r = valueArray.split(',').filter((v) => !!v) || []
  return r
}
